import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

export default function Header() {
  const { t } = useTranslation();

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.footerText}>
        <h3>AYOMI</h3>
        <p className={styles.footer}>{t('eligible.footer.description')}</p>
        <div className={styles.footerSocial}>
          <a className={styles.footerSocialIcon} href="https://www.linkedin.com/company/ayomi-fr/">
            <img className={styles.icon} src={`${process.env.PUBLIC_URL}/images/linkedin.svg`} alt="linkedin" />
          </a>
          <a className={styles.footerSocialIcon} href="https://www.facebook.com/Ayomi.IA/">
            <img className={styles.icon} src={`${process.env.PUBLIC_URL}/images/facebook.svg`} alt="facebook" />
          </a>
        </div>
      </div>
    </footer>
  );
}
